(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-selection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = scope => {
      scope.querySelectorAll('[data-brand-slider]').forEach(slider => {
        if (slider.dataset.brandSliderReady) return;
        slider.dataset.brandSliderReady = 'true';
        const rail = slider.querySelector('[data-brand-rail]');
        const controls = slider.querySelector('[data-brand-controls]');
        const previous = slider.querySelector('[data-brand-previous]');
        const next = slider.querySelector('[data-brand-next]');
        const links = [...rail.querySelectorAll('.brand-disc')];
        const behavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        const limit = () => Math.max(0, rail.scrollWidth - rail.clientWidth);
        const cardStep = () => (links[0]?.getBoundingClientRect().width || 150) + (parseFloat(getComputedStyle(rail).columnGap) || 20);
        const update = () => {
          const end = limit();
          controls.hidden = end <= 1;
          previous.disabled = rail.scrollLeft <= 2;
          next.disabled = rail.scrollLeft >= end - 2;
        };
        previous.addEventListener('click', () => rail.scrollBy({left: -Math.max(cardStep(), rail.clientWidth * 0.8), behavior: behavior()}));
        next.addEventListener('click', () => rail.scrollBy({left: Math.max(cardStep(), rail.clientWidth * 0.8), behavior: behavior()}));
        rail.addEventListener('scroll', update, {passive: true});
        rail.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const focused = event.target.closest('.brand-disc');
          if (focused) {
            const current = links.indexOf(focused);
            const target = event.key === 'Home' ? 0 : event.key === 'End' ? links.length - 1 : Math.max(0, Math.min(links.length - 1, current + (event.key === 'ArrowRight' ? 1 : -1)));
            links[target]?.focus({preventScroll: true});
            links[target]?.scrollIntoView({block: 'nearest', inline: 'nearest', behavior: behavior()});
          } else if (event.key === 'Home' || event.key === 'End') {
            rail.scrollTo({left: event.key === 'Home' ? 0 : limit(), behavior: behavior()});
          } else {
            rail.scrollBy({left: cardStep() * (event.key === 'ArrowRight' ? 1 : -1), behavior: behavior()});
          }
        });
        new ResizeObserver(update).observe(rail);
        update();
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
